import { render, staticRenderFns } from "./OtherDetail.vue?vue&type=template&id=5e48e726&scoped=true"
import script from "./OtherDetail.vue?vue&type=script&lang=js"
export * from "./OtherDetail.vue?vue&type=script&lang=js"
import style0 from "./OtherDetail.vue?vue&type=style&index=0&id=5e48e726&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e48e726",
  null
  
)

export default component.exports